<template>
  <div class="py-12 border-t">
    <div class="text-center mx-4">
      <h3 class="text-uppercase text-lg mb-1">  {{ $t('newsletter.subscribe') }} </h3>
      <h6 class="text-sm italic mb-6"> {{ $t('newsletter.subscribe_2') }} </h6>
    </div>
    <div class="flex flex-wrap justify-center mb-6 text-right" id="newsletter-row">
      <text-input id="subscriber-name" type="text" name="name" v-bind:placeholder="$t('newsletter.name')" class="w-full sm:w-1/2 md:w-1/4 lg:w-1/5 mx-4 mb-3 sm:mb-0"></text-input>
      <text-input id="subscriber-email" type="text" name="email" v-bind:placeholder="$t('newsletter.email')" class="w-full sm:w-1/2 md:w-1/4 lg:w-1/5 mx-4"></text-input>
    </div>
    <div class="flex justify-center">
      <button class="btn-gray" @click="subscribe()">
       {{$t('newsletter.subscribe_btn')}}
      </button>
    </div>
  </div>
</template>

<script>
  import TextInput from '@/Shared/TextInput';
  import "izitoast/dist/css/iziToast.min.css";
  import iziToast from 'izitoast/dist/js/iziToast.min';

  export default {
    components: {
      TextInput
    },
    methods: {
      subscribe() {
        let email = document.getElementById('subscriber-email').value;
        let name = document.getElementById('subscriber-name').value;

        axios.post('/api/subscribe', {
          email:email,
          name: name,
          locale: window.locale
        }).then((response)=>{
          iziToast.show({
            class: 'success',
            message:response.data.message,
            color:'green',
            position:'topCenter',
            transitionIn: 'bounceInLeft',
            progressBar: false,
            timeout: 5000,
            displayMode: 'replace'
          });
        }).catch((error)=>{
          console.log(error);
          if(error.response){
            iziToast.show({
              class: 'error',
              message:error.response.data.message,
              color:'red',
              position:'topCenter',
              transitionIn: 'bounceInLeft',
              progressBar: false,
              timeout: 5000,
              displayMode: 'replace'
            });
          }
          else {
            iziToast.show({
              class: 'error',
              message:'Eroare la trimiterea cererii de abonare',
              color:'red',
              position:'topCenter',
              transitionIn: 'bounceInLeft',
              progressBar: false,
              timeout: 5000,
              displayMode: 'replace'
            });
          }
        });
      }
    }
  }
</script>
